export default {
  getList: () => ['pipeline', 'list'],
  getDetail: (id) => ['pipeline', 'detail', id],
  getBuildSource: (id) => ['pipeline', 'build-source', id],
  getRuns: (id) => ['pipeline', 'runs', id],
  getRun: (id, runId) => ['pipeline', 'run', id, runId],
};
